<div>
  <div class="widget-title">
    <div>
      <div>Shift Validations</div>
    </div>
  </div>

  <app-shift-charts [statistics]="statistics$ | async" [hidden]="(statistics$ | async) === undefined || !shiftId"></app-shift-charts>

  <div class="no-items" *ngIf="(statistics$ | async) === undefined && shiftId">
    <mat-card>
      <mat-card-content>
        <mat-icon>block</mat-icon>
        <span>No statistics for this shift available</span>
      </mat-card-content>
    </mat-card>
  </div>

  <mat-card *ngFor="let validation of validations$ | async" (click)="toggleValidation(validation)">
    <mat-card-content>
      <mat-icon [style.color]="getSeverityColor(validation.severity)">{{ getSeverityIcon(validation.severity) }}</mat-icon>
      <span [class.confirmed]="validation.isAccepted">{{ validation.message }}</span>
      <ng-container *ngIf="validation.isAccepted">
        Accepted by {{ validation.acceptedBy.firstName }} {{ validation.acceptedBy.lastName }} at {{ validation.updatedAt | date: 'dd-MM-YYYY HH:mm:ss' }}
      </ng-container>
    </mat-card-content>
  </mat-card>

  <div class="no-items" *ngIf="(validations$ | async)?.length === 0 && shiftId">
    <mat-card>
      <mat-card-content>
        <mat-icon>done</mat-icon>
        <span>This shift is valid</span>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="no-items" *ngIf="!shiftId">
    <mat-card>
      <mat-card-content>
        <mat-icon>crop_free</mat-icon>
        <span>Selected cell has not shift assigned</span>
      </mat-card-content>
    </mat-card>
  </div>
</div>
